export default __webpack_public_path__ + "static/media/loginImg2.30a930a0.png";